import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const BackArrowIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1791 20.4476C11.3736 20.6436 11.3724 20.9602 11.1764 21.1547C10.9804 21.3492 10.6638 21.348 10.4693 21.152L0.647804 11.2549C0.647057 11.2542 0.646314 11.2534 0.645572 11.2527C0.645413 11.2525 0.645254 11.2524 0.645094 11.2522C0.474896 11.0807 0.45455 10.8169 0.583434 10.6233C0.601284 10.5965 0.621998 10.571 0.645572 10.5473C0.646314 10.5466 0.647057 10.5458 0.647804 10.5451L10.4693 0.648008C10.6638 0.452 10.9804 0.450787 11.1764 0.645298C11.3724 0.839811 11.3736 1.15639 11.1791 1.3524L1.70441 10.9L11.1791 20.4476Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default BackArrowIcon;

BackArrowIcon.propTypes = customIconsPropTypes;
